import React, { Component } from 'react';
import Brand from '../data/brand.js';

class Brands extends Component {
    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this)
    }

    render() {
        const brandData = Brand;

        return (
            <div className="section fp-auto-height-responsive" data-tooltip="OUR BRANDS">
                <div className="container container-width p-5">
                    <div className="row p-4 d-flex justify-content-center">
                        {this.renderLogos(brandData, this.handleClick)}
                    </div>
                </div>
            </div>
        );
    }

    renderLogos(brandData, handleClick) {
        let values = Object.keys(brandData).map(function(e) {
            return brandData[e];
        });

        const paragraph = {
            fontSize: '1.2em',
            textAlign: 'left',
            margin: '0px',
            color: 'black',
        };

        const img = {
            maxWidth: '90%',
        };

        return (
            values.map(function(element, index) {
                return (
                    <div key={index} className="col-xs-12 col-sm-6 col-md-4 col-lg-3 pt-5 pb-5 pl-2 pr-2 d-flex align-items-center justify-content-center">
                        {
                            element.type === 'text' ? (
                                <p style={paragraph}>{element.text}</p>
                            ) : element.type === 'link' ? (
                                <a href={element.link} target="_blank" rel="noopener noreferrer"><img className="img-fluid" style={img} src={element.logo} alt="icon"/></a>
                            ) : (
                                <img className="img-fluid" style={img} src={element.logo} alt="icon" onClick={handleClick}/>
                            )
                        }
                    </div>
                );
            })
        );
    }

    handleClick() {
        console.log('CLICKED');
    }
};

export default Brands;



// WEBPACK FOOTER //
// ./src/pages/brands.js